import { BaseNode } from "../baseNode";
import { nodeConfigs } from "../nodeConfigs";
export const LLMNode = ({ id, data }) => (
  <BaseNode id={id} data={data} config={nodeConfigs.llm} />
);
